import { CADASTRAR_CONFIGURACAO_EXCESSO_BAGAGEM, BUSCAR_CONFIGURACAO_EXCESSO_BAGAGEM } from '../../actions/types'

const estadoInicial = {
  id: null,
  habilitadoPrecoKg: false,
  precoKg: null,
  habilitadoPrecoFixoMaisValorKg: false,
  valorKg: null,
  precoFixo: null,
  habilitadoTaxaSeguro: false,
  taxaSeguro: null,
  mensagem: null,
  tiposCalculoBagagem: [],
  habilitadoPrecoMetroCubico: false,
  precoMetroCubico: null,
}

export default function reducerConfiguracaoExcessoBagagem(state = estadoInicial, action = undefined) {
  switch (action.type) {
    case CADASTRAR_CONFIGURACAO_EXCESSO_BAGAGEM: {
      return action.payload.data
    }

    case BUSCAR_CONFIGURACAO_EXCESSO_BAGAGEM: {
      if (action.payload.data) {
        return action.payload.data
      }
      return estadoInicial
    }

    default: {
      return state
    }
  }
}
